import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../utils/api';
import { useI18n } from '../i18n/I18nProvider';

const ERROR_KEYS = {
  token_already_used: 'verify.used',
  token_expired:      'verify.expired',
  invalid_token:      'verify.invalid',
  token_required:     'verify.noToken',
};

// VerifyPage consumes the e-mail-verification link: it reads ?token, calls
// GET /v1/auth/verify, and reports the outcome (PIN-224).
const VerifyPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { t } = useI18n();
  const [status, setStatus]     = useState('loading'); // loading | ok | error
  const [errorKey, setErrorKey] = useState('verify.invalid');

  useEffect(() => {
    if (!token) { setStatus('error'); setErrorKey('verify.noToken'); return undefined; }
    let cancelled = false;
    api.verifyEmail(token).then(async (res) => {
      if (cancelled) return;
      if (res.ok) { setStatus('ok'); return; }
      const d = await res.json().catch(() => ({}));
      setStatus('error');
      setErrorKey(ERROR_KEYS[d.error] || 'verify.invalid');
    }).catch(() => { if (!cancelled) { setStatus('error'); setErrorKey('verify.invalid'); } });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="uh-login-container">
      <div className="uh-card" style={{ width: 'min(440px, 94vw)', padding: 32, textAlign: 'center' }}>
        <div className="uh-login-subtitle" style={{ marginBottom: 16 }}>{t('app.brand')}</div>
        <h1 className="uh-title" style={{ fontSize: 22, marginBottom: 16 }}>{t('verify.title')}</h1>
        {status === 'loading' && <p className="uh-muted">{t('verify.checking')}</p>}
        {status === 'ok' && (
          <>
            <div className="uh-alert-success">{t('verify.ok')}</div>
            <Link className="uh-btn uh-btn-primary" to="/dashboard" style={{ marginTop: 16 }}>{t('verify.toDashboard')}</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="uh-alert-error">{t(errorKey)}</div>
            <Link className="uh-btn" to="/dashboard" style={{ marginTop: 16 }}>{t('verify.toDashboard')}</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
